// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MyFeeds_wrapper__16b0K","feeds":"MyFeeds_feeds__erSWs","feed":"MyFeeds_feed__3Vv6-","name":"MyFeeds_name__3IC6z","spinner":"MyFeeds_spinner__2u6vj"};